var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "to-valiview" },
    [
      _vm._m(0),
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.QRShow,
                expression: "QRShow"
              }
            ],
            staticClass: "QR-box"
          },
          [
            _c(
              "el-card",
              { staticClass: "qr-info", attrs: { shadow: "hover" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [
                    _c("h2", [_vm._v("基本信息")]),
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "right", padding: "3px 0" },
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.QRShow = false
                          }
                        }
                      },
                      [_vm._v("验证查看合同")]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  { staticClass: "qr-form" },
                  [
                    _c(
                      "el-form-item",
                      { staticClass: "m-0", attrs: { label: "文档名称：" } },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.QRInfo.contractInfo.contractName))
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "m-0", attrs: { label: "发起人：" } },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.QRInfo.contractInfo.platform))
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "m-0", attrs: { label: "签约编号：" } },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.QRInfo.contractInfo.applyNo))
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "m-0",
                        attrs: { label: "保全文件Hash(SHA512算法)：" }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.QRInfo.contractInfo.hash))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-card",
              { staticClass: "qr-info", attrs: { shadow: "hover" } },
              [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("h2", [_vm._v("签署信息")])
                ]),
                _c(
                  "div",
                  { staticClass: "qr-form" },
                  _vm._l(_vm.QRInfo.qrcodeSignInfos, function(user) {
                    return _c(
                      "el-form",
                      { key: user.idNo },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "m-0",
                            attrs: { label: "签署主体：" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(user.name) +
                                  "（" +
                                  _vm._s(user.idNo) +
                                  "）"
                              )
                            ])
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "m-0",
                            attrs: { label: "签署时间：" }
                          },
                          [_c("span", [_vm._v(_vm._s(user.signTime))])]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "m-0",
                            attrs: { label: "最终备案号：" }
                          },
                          [_c("span", [_vm._v(_vm._s(user.presId))])]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "m-0",
                            attrs: { label: "证书序列号：" }
                          },
                          [_c("span", [_vm._v(_vm._s(user.sn))])]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "m-0",
                            attrs: { label: "证书颁发机构：" }
                          },
                          [_c("span", [_vm._v(_vm._s(user.issuer))])]
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ]
            )
          ],
          1
        ),
        _c(
          "el-card",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.QRShow,
                expression: "!QRShow"
              }
            ],
            staticClass: "card",
            attrs: { shadow: "never" }
          },
          [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("el-input", {
                  attrs: { disabled: true },
                  model: {
                    value: _vm.current.idenNameMask,
                    callback: function($$v) {
                      _vm.$set(_vm.current, "idenNameMask", $$v)
                    },
                    expression: "current.idenNameMask"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择" },
                    on: { change: _vm.onSelected },
                    model: {
                      value: _vm.current.select,
                      callback: function($$v) {
                        _vm.$set(_vm.current, "select", $$v)
                      },
                      expression: "current.select"
                    }
                  },
                  _vm._l(_vm.signatoryInfo, function(item, i) {
                    return _c("el-option", {
                      key: i,
                      attrs: { label: item.idenCardMask, value: i }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("el-input", {
                  attrs: { disabled: true },
                  model: {
                    value: _vm.current.targetMask,
                    callback: function($$v) {
                      _vm.$set(_vm.current, "targetMask", $$v)
                    },
                    expression: "current.targetMask"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "el-input",
                  {
                    attrs: { placeholder: "请输入验证码" },
                    model: {
                      value: _vm.current.valiCode,
                      callback: function($$v) {
                        _vm.$set(_vm.current, "valiCode", $$v)
                      },
                      expression: "current.valiCode"
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "append" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.countdownInfo.start,
                              type: "success"
                            },
                            on: { click: _vm.sendCode }
                          },
                          [
                            _vm.countdownInfo.start
                              ? [
                                  _c("countdown", {
                                    attrs: { start: _vm.countdownInfo.start },
                                    on: {
                                      "on-finish": _vm.handleCountdownFinish
                                    },
                                    model: {
                                      value: _vm.countdownInfo.time,
                                      callback: function($$v) {
                                        _vm.$set(_vm.countdownInfo, "time", $$v)
                                      },
                                      expression: "countdownInfo.time"
                                    }
                                  })
                                ]
                              : [_vm._v("发送验证码")]
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ],
              1
            ),
            _vm.countdownInfo.needImg
              ? _c(
                  "div",
                  { staticClass: "row imageCode" },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "图形验证码" },
                        model: {
                          value: _vm.countdownInfo.imgCode,
                          callback: function($$v) {
                            _vm.$set(_vm.countdownInfo, "imgCode", $$v)
                          },
                          expression: "countdownInfo.imgCode"
                        }
                      },
                      [
                        _c(
                          "template",
                          { slot: "append" },
                          [
                            _c("img-auth", {
                              ref: "imgAuthCode",
                              attrs: {
                                size: "small",
                                "verify-type": 20,
                                "img-token": _vm.countdownInfo.imgToken
                              },
                              on: {
                                "update:imgToken": function($event) {
                                  return _vm.$set(
                                    _vm.countdownInfo,
                                    "imgToken",
                                    $event
                                  )
                                },
                                "update:img-token": function($event) {
                                  return _vm.$set(
                                    _vm.countdownInfo,
                                    "imgToken",
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { type: "danger" },
                    on: { click: _vm.certiVali }
                  },
                  [_vm._v("确认")]
                )
              ],
              1
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("img", { attrs: { src: "/images/htb_banner_2.jpg" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0506866a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0506866a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/certi/toValiView.vue
// module id = FsjX
// module chunks = 144